import { endpointWrapper } from './meta.api';

const shapeUserAbout = (userAbout) => {
    if (!userAbout) return userAbout;
    return {
        ...userAbout,
        hasTikTokAccess: userAbout?.data_sources?.includes('tiktok'),
    };
};

export const fetchUserAbout = () =>
    endpointWrapper({ domain: 'user/about', method: 'GET' }).then(
        shapeUserAbout,
    );

export const addUser = () => endpointWrapper({ domain: 'user/add' });

export const setPreferredCountry = (country) =>
    endpointWrapper({
        domain: 'user/set-prefered-country',
        data: { country },
    });

export const agreeTerms = () => endpointWrapper({ domain: 'user/agree-terms' });
export const agreeTracking = () =>
    endpointWrapper({ domain: 'user/agree-tracking' });
